import React from "react";
import "./sidebar.css";
import { Link } from "react-router-dom";

function Sidebar() {
  return (
    <div className="sidebar">
      <li>
        <Link to={"/home"} className="home" title="Home">
          <i className="glyphicon glyphicon-home" />
        </Link>
      </li>
    </div>
  );
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/shared/components/sidebar.js